import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.string.replace-all.js";
import { contractPlanInfo } from './../request';
export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {},
      replaceName: ['年交', '月交', '季交', '周交', '年', '天']
    };
  },
  computed: {
    paymentDeadlineName() {
      let _value = this.dataFrom.paymentDeadlineName;
      let _replaceName = this.replaceName;
      _replaceName.forEach(item => {
        _value = _value.replaceAll(item, this.$t(item));
      });
      return this.$t(_value);
    },
    durationName() {
      let _value = this.dataFrom.durationName;
      let _replaceName = this.replaceName;
      _replaceName.forEach(item => {
        _value = _value.replaceAll(item, this.$t(item));
      });
      return _value;
    }
  },
  methods: {
    init(val) {
      contractPlanInfo({
        contractPlanId: val.id
      }).then(res => {
        console.log(res, 44);
        this.dataFrom = res;
        if (res.rights.length == 0) {
          this.dataFrom.rights = [{
            name: '',
            value: '',
            info: ''
          }];
        }
      });
      this.dialogVisible = true;
    }
  }
};